















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { addDecimalPointToNumbers } from '@/utils/formats';
@Component({})
export default class PercentageTable extends Vue {
  @Prop({
    type: Object,
    default: null,
  })
  reportValues!: any;

  standardizeValues(data: number) {
    const value = addDecimalPointToNumbers(data);
    return value;
  }
}
